import { RootState } from "@/store/dtm";
import { addressType } from "@/types/addressType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface homeAddressState {
    address: addressType,
    mailingAddressSame: boolean
}

const initialState: homeAddressState = {
    address: {
        id: 0,
        streetNumber: "",
        streetName: "",
        streetType: "",
        streetDirection: "",
        unitType: "",
        unitNumber: "",
        city: "",
        province: "",
        postalCode: "",
        country: "",
    },
    mailingAddressSame: true
}


export const homeAddressSlice = createSlice({
    name: "homeAddress",
    initialState,
    reducers: {
        setAddressId: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.address.id = id;
        },
        setStreetNumber: (state, action: PayloadAction<string>) => {
            const streetNumber = action.payload;
            state.address.streetNumber = streetNumber;
        },
        setStreetName: (state, action: PayloadAction<string>) => {
            const streetName = action.payload;
            state.address.streetName = streetName;
        },
        setStreetType: (state, action: PayloadAction<string>) => {
            const streetType = action.payload;
            state.address.streetType = streetType;
        },
        setStreetDirection: (state, action: PayloadAction<string>) => {
            const streetDirection = action.payload;
            state.address.streetDirection = streetDirection;
        },
        setUnitType: (state, action: PayloadAction<string>) => {
            const unitType = action.payload;
            state.address.unitType = unitType;
        },
        setUnitNumber: (state, action: PayloadAction<string>) => {
            const unitNumber = action.payload;
            state.address.unitNumber = unitNumber;
        },
        setCity: (state, action: PayloadAction<string>) => {
            const city = action.payload;
            state.address.city = city;
        },
        setProvince: (state, action: PayloadAction<string>) => {
            const province = action.payload;
            state.address.province = province;
        },
        setPostalCode: (state, action: PayloadAction<string>) => {
            const postalCode = action.payload;
            state.address.postalCode = postalCode;
        },
        setCountry: (state, action: PayloadAction<string>) => {
            const country = action.payload;
            state.address.country = country;
        },
        setMailingAddressSame: (state, action: PayloadAction<boolean>) => {
            const mailingAddressSame = action.payload;
            state.mailingAddressSame = mailingAddressSame;
        },

        clearAddressState: (state) => {
            state.address.id = 0;
            state.address.streetNumber = "";
            state.address.streetName = "";
            state.address.streetType = "";
            state.address.streetDirection = "";
            state.address.unitNumber = "";
            state.address.city = "";
            state.address.province = "";
            state.address.postalCode = "";
            state.address.country = "";
            state.mailingAddressSame = true;
        }
    }
});

export const { setAddressId,setStreetNumber, setUnitNumber, setStreetName, setStreetType, setStreetDirection, setCity, setProvince, setUnitType,
                setPostalCode, setCountry, setMailingAddressSame, clearAddressState } = homeAddressSlice.actions

export default homeAddressSlice.reducer

export const selectHomeAddress = (state: RootState) => state.homeAddress;

